export const TRACKING_STEP_CHOISE_DEFAULT = 'default';
export const TRACKING_STEP_CHOISE_CHOOSE = 'choose';
